/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Protocol_Delivery_Hint_EmailInputs */

const cs_tasks_protocol_delivery_hint_email = /** @type {(inputs: Tasks_Protocol_Delivery_Hint_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signi pošle e-mail (a SMS, pokud je telefon) každému signatáři.`)
};

const en_tasks_protocol_delivery_hint_email = /** @type {(inputs: Tasks_Protocol_Delivery_Hint_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signi emails (and SMS if phone is set) each signer.`)
};

/**
* | output |
* | --- |
* | "Signi emails (and SMS if phone is set) each signer." |
*
* @param {Tasks_Protocol_Delivery_Hint_EmailInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const tasks_protocol_delivery_hint_email = /** @type {((inputs?: Tasks_Protocol_Delivery_Hint_EmailInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Protocol_Delivery_Hint_EmailInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_protocol_delivery_hint_email(inputs)
	return cs_tasks_protocol_delivery_hint_email(inputs)
});